<template>
  <el-form :model="navigateData" ref="warehouseForm" label-width="15%" class="demo-warehouseForm">
    <el-form-item :label="generateCustomizeString('categories')">
      <el-select v-model="categoryId" :placeholder="generateCustomizeString('pleaseSelect')">
        <el-option v-for="item in categoriesOptions" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item :label="generateCustomizeString('sortWeight')">
      <el-input v-model="navigateData.sort_by"></el-input>
    </el-form-item>

    <el-form-item :label="generateCustomizeString('isShow')">
      <el-switch v-model="navigateData.is_show" :active-text="generateCustomizeString('moduleReady')" :inactive-text="generateCustomizeString('moduleWaitForReview')"></el-switch>
    </el-form-item>

    <el-form-item>
      <el-button v-if="isEdit" type="primary" @click="updateClick" plain>{{generateCustomizeString('update')}} </el-button>
      <el-button v-if="!isEdit" type="primary" @click="createClick">{{generateCustomizeString('create')}}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

const defaultNavigate = {
  related_data: [],
  sort_by: 0,
  type: 1,
  cms_home_category_id: 0,
  is_show: false
}

export default {
  name: 'NavigateDetail',

  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    isView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      navigateData: Object.assign({}, defaultNavigate),
      categoriesOptions: []
    }
  },
  methods: {
    generateCustomizeString,
    createClick() {
      this.createNavigate()
    },
    updateClick() {
      this.updateNavigate()
    },
    fetchCategories() {
      return new Promise((resolve, reject) => {
        request({
          url: '/categories',
          method: 'get'
        })
          .then(response => {
            const data = response.data
            for (let i = 0; i < response.data.length; i++) {
              var obj = {}
              obj.value = response.data[i].id
              obj.label = response.data[i].name
              data[i] = obj
            }
            this.categoriesOptions = data

            resolve()
          })
          .catch(error => {
            console.warn(error)
            reject(error)
          })
      })
    },
    createNavigate() {
      var data = {
        related_data: this.navigateData.related_data,
        sort_by: this.navigateData.sort_by,
        type: 1,
        cms_home_category_id: this.$route.params.cms_home_category_id,
        is_show: this.navigateData.is_show
      }
      request({
        url: 'cms-category-item',
        method: 'post',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('createdSuccessfully'),
              type: 'success'
            })
            this.$router.push({
              name: 'PcNavigate',
              params: {
                cms_home_category_id: this.$route.params.cms_home_category_id
              }
            })
          } else {
            this.$message.error(this.generateCustomizeString('createFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('createFailed'))
        })
    },
    fetchNavigate() {
      request({
        url: 'cms-category-item/' + this.$route.params.categoryId,
        method: 'get'
      })
        .then(res => {
          if (res.status === 0) {
            // 更新数据
            for (const i in this.navigateData) {
              this.navigateData[i] = res.data[i]
              if (i === 'is_show') {
                this.navigateData.is_show = res.data[i] === 1
              }
            }
            console.log(this.navigateData)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    updateNavigate() {
      var data = {
        related_data: this.navigateData.related_data,
        sort_by: this.navigateData.sort_by,
        type: 1,
        cms_home_category_id: this.$route.params.cms_home_category_id,
        is_show: this.navigateData.is_show
      }
      request({
        url: 'cms-category-item/' + this.$route.params.categoryId,
        method: 'put',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('updateSuccessfully'),
              type: 'success'
            })
            this.$router.push({
              name: 'PcNavigate',
              params: {
                cms_home_category_id: this.$route.params.cms_home_category_id
              }
            })
          } else {
            this.$message.error(this.generateCustomizeString('updateFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('updateFailed'))
        })
    }
  },

  created() {
    this.fetchLoding = true
    Promise.all([this.fetchCategories()])
      .then(result => {})
      .catch(error => {
        console.warn(error)
      })
      .finally(() => {
        this.fetchLoding = false
      })
    if (this.isEdit) {
      this.fetchNavigate()
    } else {
      this.navigateData = Object.assign({}, defaultNavigate)
    }
  },
  computed: {
    categoryId: {
      get: function() {
        return parseInt(this.navigateData.related_data[0])
      },
      set: function(newValue) {
        this.navigateData.related_data = [newValue]
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.demo-warehouseForm {
  padding: 50px 50px 0px 50px;
}
</style>
